import { createContext, useContext, type ReactNode } from 'react';

export type VersionedRecord = {
  id: string;
  version?: number;
  is_active?: boolean;
  updated_at?: string;
};

export type MagicFlowVersionsContextValue = {
  versions: VersionedRecord[];
  activatingId?: string;
  isActivatingPending?: boolean;
  onActivate: (id: string) => void;
  onSelect?: (id: string) => void;
  currentId?: string;
  emptyText?: string;
};

const MagicFlowVersionsContext =
  createContext<MagicFlowVersionsContextValue | null>(null);

type MagicFlowVersionsProviderProps = MagicFlowVersionsContextValue & {
  children: ReactNode;
};

export const MagicFlowVersionsProvider = ({
  children,
  ...value
}: MagicFlowVersionsProviderProps) => {
  return (
    <MagicFlowVersionsContext.Provider value={value}>
      {children}
    </MagicFlowVersionsContext.Provider>
  );
};

export const useMagicFlowVersionsContext =
  (): MagicFlowVersionsContextValue => {
    const value = useContext(MagicFlowVersionsContext);
    if (!value) {
      throw new Error(
        'useMagicFlowVersionsContext must be used within a MagicFlowVersionsProvider'
      );
    }
    return value;
  };
